export const SOCIALS = {
  youtube: "https://www.youtube.com/@weneedtotalkofficial01?sub_confirmation=1",
  tiktok: "https://www.tiktok.com/@weneedtotalkofficial?_r=1&_t=ZP-98uWt9c8f78",
  instagram: "https://www.instagram.com/weneedtotalkofficial01?igsh=MWI3bmxod28zMHU3dQ%3D%3D&utm_source=qr",
  facebook: "https://www.facebook.com/share/1U1KBrJT4j/?mibextid=wwXIfr",
};

export const CHARACTERS = [
  {
    id: "james",
    name: "JAMES",
    role: "THE FATHER",
    tagline: "58. Husband. Father. Keeper of hard-earned wisdom.",
    img: "/assets/img/james.jpg",
    bio: "James has spent a lifetime learning lessons the hard way so his children won't have to. He speaks slowly, loves fiercely, and believes most wounds in a family begin with a conversation that never happened.",
    quote: "Never be too proud to repair what you broke.",
  },
  {
    id: "linda",
    name: "LINDA",
    role: "THE MOTHER",
    tagline: "56. Wife. Mother. Compassionate truth-teller.",
    img: "/assets/img/linda.jpg",
    bio: "Linda holds the family together with equal parts tenderness and truth. She says the thing nobody wants to say — because she knows silence is its own kind of wound.",
    quote: "Intent doesn't erase impact.",
  },
  {
    id: "marcus",
    name: "MARCUS",
    role: "THE SON",
    tagline: "30. Husband. Still learning what love requires.",
    img: "/assets/img/marcus.jpg",
    bio: "Marcus married young and certain. Now he's discovering that love is not a feeling you keep — it's a skill you practice, one honest conversation at a time.",
    quote: "Your wife isn't your enemy.",
  },
  {
    id: "aaliyah",
    name: "AALIYAH",
    role: "THE DAUGHTER",
    tagline: "29. Independent. Intelligent. Learning to see love clearly.",
    img: "/assets/img/aaliyah.jpg",
    bio: "Aaliyah built a life on her own terms. Now she has to decide which voices to trust — including her own — when love stops looking the way she imagined.",
    quote: "Attention makes you feel wanted. Love makes you feel safe.",
  },
];

// videoId: paste the YouTube video ID (the part after watch?v=) when each episode premieres.
// teaser: local teaser video plays in the cinematic modal until the episode drops.
// premiere: ISO datetime used by the live countdown.
export const EPISODES = [
  {
    num: 1,
    title: "SON, YOUR WIFE IS NOT YOUR ENEMY",
    desc: "Sometimes your spouse isn't asking you to fix the problem. They're asking you to understand it.",
    img: "/assets/img/ep1.jpg",
    videoId: "47oD9IQZ5as",
    teaser: "/assets/video/teaser-ep1.mp4",
    premiere: "2026-08-17T12:00:00",
  },
  {
    num: 2,
    title: "DAUGHTER, DON'T MARRY POTENTIAL",
    desc: "Don't build a marriage around who someone might become. Look at who they are becoming now.",
    img: "/assets/img/ep2.jpg",
    videoId: "pF1CnWSe-gQ",
    teaser: "/assets/video/teaser-ep2.mp4",
    premiere: "2026-08-19T12:00:00",
  },
  {
    num: 3,
    title: "SON, LEARN TO SAY I'M SORRY",
    desc: "An apology isn't just saying the words. It's understanding the hurt and being willing to do better.",
    img: "/assets/img/ep3.jpg",
    videoId: "FGWOW5WvMDo",
    teaser: "/assets/video/teaser-ep3.mp4",
  },
  {
    num: 4,
    title: "DON'T CONFUSE ATTENTION WITH LOVE",
    desc: "Attention makes you feel wanted. Love makes you feel safe.",
    img: "/assets/img/ep4.jpg",
    videoId: null,
    hidden: true,
  },
  {
    num: 5,
    title: "SON, YOUR WIFE IS NOT YOUR MOTHER",
    desc: "Marriage is partnership, not parenthood.",
    img: "/assets/img/ep5.jpg",
    videoId: null,
    hidden: true,
  },
  {
    num: 6,
    title: "DAUGHTER, WATCH HOW HE TREATS PEOPLE WHO CAN'T DO ANYTHING FOR HIM",
    desc: "Character reveals itself when there is nothing to gain.",
    img: "/assets/img/ep6.jpg",
    videoId: null,
    hidden: true,
  },
];

export const LATEST_EPISODE = {
  ...EPISODES[2],
  synopsis:
    "In the study, beneath the wedding photo still hanging on the wall, Marcus insists he already apologized. James asks the harder question — did you mean it? — and shows him that knowing when to put your pride down is one of the strongest things a man can do.",
};

export const LESSONS = [
  "LOVE",
  "MARRIAGE",
  "FAMILY",
  "FORGIVENESS",
  "TRUST",
  "COMMUNICATION",
  "PARENTING",
  "SELF-WORTH",
  "PRIDE",
  "HEALING",
];

export const QUOTES = [
  "Your wife isn't your enemy.",
  "Don't marry potential. Marry character.",
  "Intent doesn't erase impact.",
  "Attention makes you feel wanted. Love makes you feel safe.",
  "Don't make the woman you love raise the man she married.",
  "Never be too proud to repair what you broke.",
];

// ---------- Editable site defaults (the admin studio overrides these via the database) ----------
export const SITE = {
  hero: {
    bg: "/assets/img/hero-family.jpg",
    overline: "An original family-drama series",
    subheadline: "\u201cSome conversations come too late.\u201d",
    supporting:
      "A cinematic family-drama series about love, marriage, family, and the conversations that can change everything.",
    familyLabel: "Meet the family",
  },
  marquee: [
    "SOME CONVERSATIONS COME TOO LATE",
    "REAL CONVERSATIONS",
    "REAL LESSONS",
    "REAL LIFE",
    "AN ORIGINAL FAMILY-DRAMA SERIES",
  ],
  sound: {
    tagline: "\u201cEvery family has a conversation waiting to happen.\u201d",
    trackTitle: "We Need To Talk \u2014 Official Theme",
    trackSrc: "/assets/audio/theme.mp3",
  },
  story: {
    paras: [
      "Every family has things they don't say.",
      "The conversations about marriage. The conversations about love. The conversations about mistakes. The conversations about forgiveness. The conversations we wish someone had with us before life taught us the hard way.",
      "WE NEED TO TALK brings those conversations to life through emotional cinematic stories about family, relationships and the choices that shape us.",
    ],
    image: "/assets/img/story-family.jpg",
    caption: "A family. A table. The things left unsaid.",
  },
  family: { side: "Four people. One home. A lifetime of things worth saying." },
  episodesSide: "Six conversations every family needs to have. New episodes every week.",
  lessonsHover: "Sometimes the conversation changes everything.",
  watch: { tagline: "\u201cFollow the family. Join the conversation.\u201d" },
  newsletter: {
    overline: "The next episode is coming",
    headingMain: "DON'T MISS THE NEXT",
    headingAccent: "CONVERSATION",
    body: "New stories, new lessons, and new conversations delivered when the next episode arrives.",
  },
  creator: {
    text: "WE NEED TO TALK is an original family-drama storytelling project created to explore the conversations that shape love, marriage, family and life.",
    producedBy: "OLAMILEKAN OLATUNJI",
    writtenBy: "OLAMILEKAN OLATUNJI",
    image: "/assets/img/creator.jpg",
  },
  sections: [
    { id: "sound", label: "Musical Identity", visible: true },
    { id: "story", label: "About the series", visible: true },
    { id: "family", label: "The cast", visible: true },
    { id: "episodes", label: "Season one", visible: true },
    { id: "latest", label: "Latest conversation", visible: true },
    { id: "lessons", label: "The lessons", visible: true },
    { id: "quotes", label: "Words to carry", visible: true },
    { id: "watch", label: "Stream the series", visible: true },
    { id: "newsletter", label: "Join the conversation", visible: true },
    { id: "creator", label: "Behind the series", visible: true },
  ],
};

// Raw editable document shape (what the admin studio edits and saves)
export const defaultSiteDoc = () =>
  JSON.parse(
    JSON.stringify({
      episodes: EPISODES,
      latestEpisodeNum: LATEST_EPISODE.num,
      latestSynopsis: LATEST_EPISODE.synopsis,
      socials: SOCIALS,
      quotes: QUOTES,
      lessons: LESSONS,
      characters: CHARACTERS,
      hero: SITE.hero,
      marquee: SITE.marquee,
      sound: SITE.sound,
      story: SITE.story,
      family: SITE.family,
      episodesSide: SITE.episodesSide,
      lessonsHover: SITE.lessonsHover,
      watch: SITE.watch,
      newsletter: SITE.newsletter,
      creator: SITE.creator,
      sections: SITE.sections,
    })
  );
